import {useMutation, useQueryClient} from "@tanstack/react-query";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS, RECOMMENDATION_ENDPOINTS} from "../../services/network/endpoints";
import {IEvent, IEventCreate} from "../../services/models/event";
import {toast} from "react-toastify";
import {RecommendationsApi} from "../../services/network/recommendation-api";

export function useDeleteRecom(sectorId: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [RECOMMENDATION_ENDPOINTS.DELETE],
        mutationFn: (id:string) => RecommendationsApi.deleteRecommendation(id),
        onError() {
            toast.error("Ошибка удаления события");
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_BY_SECTOR,sectorId] });
            toast.success("Событие успешно удалено");
        }
    });
}
